<template>
  <div>
    <div class="culturalhistory">
      <div class="bannerbg" @click="handlevideoAction()">
        <img
            src="~@/assets/images/mainindex/cultural.png"
            class="bannerbg_pic"
        />
        <div>
          <div class="bannerbg_desc" v-if="false">
            <div class="bannerbg_desc_title">啦啦操俱乐部</div>
            <div class="bannerbg_desc_entitle">CCA Club</div>
          </div>
        </div>
      </div>

      <div class="container_wrap">
        <ColumnTitle title="文化纪风采" subtitle="全面推进素质教育，提升学生综合素质，提高孩子参与体育运动积极性"></ColumnTitle>
        <div class="wenhuaji-img flex-start">
   
          <img @click="onWhjDetail"
               src="https://bc2026.oss-ap-southeast-1.aliyuncs.com/uploader/000/user-xxx/vc-upload-1636097067736-7.jpeg?x-oss-process=style/tb-750"
               alt="">
          <img @click="onWhjDetail"
               src="https://bc2026.oss-ap-southeast-1.aliyuncs.com/editor/20210630/user-0/20210630/3e44554811dab30d506930d16a9b822e.jpg?x-oss-process=style/tb-750"
               alt="">
        </div>
        <ColumnTitle title="大课间" subtitle="千万学生跳动啦啦操大课间"></ColumnTitle>
        <div class="wenhuaji-img flex-start">
          <img @click="onDkjDetail"
          style="width:390px;margin:0 auto"
               src="https://bc2026.oss-ap-southeast-1.aliyuncs.com/editor/20210630/user-0/20210630/c69402490ed4b288c5bc02b5d92bcee2.jpeg?x-oss-process=style/tb-750"
               alt=""> 
        </div>


        <div v-if="false" class="bannerbg" @click="handlevideoAction()">
          <img
              src="~@/assets/images/mainindex/cultural-video@2x.png"
              class="bannerbg_pic"
              v-if="!videoAction"
          />
          <video
              ref="myVideo"
              preload="auto"
              src="https://bc2026.oss-ap-southeast-1.aliyuncs.com/uploader/000/user-xxx/vc-upload-1599486954084-6.mp4"
              controls="controls"
          >
            您的浏览器不支持 video 标签。
          </video>
          <div v-if="!videoAction">
            <div class="bannerbg_desc">
              <div class="bannerbg_desc_title">啦啦操俱乐部</div>
              <div class="bannerbg_desc_entitle">CCA Club</div>
            </div>
            <img
                src="~@/assets/images/mainindex/cultural-video-play@2x.png"
                alt=""
                class="banner_videoplay_icon"
            />
          </div>
        </div>


<!--        <ColumnTitle title="行业精英" subtitle="全国啦啦操优秀代表行业精英"></ColumnTitle>-->

        <div v-if="false" class="tradeelite">
          <div class="header_screen container_wrap">
            <div class="header_screen_item">
              <div class="header_screen_item_els">
                <div
                    class="header_screen_item_el"
                    v-for="(item, index) in cateList"
                    :key="index"
                    :class="item.name === activeName ? 'header_screen_item_el_active' : ''"
                    @click="onSelectType(item)"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="star_list container_wrap">
            <div
                class="star_list_item_wrap"
                v-for="(item, index) in personList"
                :key="index"
                @click="toDetail(item.id)"
            >
              <div class="star_list_item">
                <div class="star_list_item_pic">
                  <img v-if="item.pics.length > 0" :src="item.pics[0].url" alt=""/>
                </div>
                <div class="star_list_item_right">
                  <div class="star_list_item_right_name">{{ item.title }}</div>
                  <div class="star_list_item_right_des">{{ item.desc }}</div>
                  <div class="star_list_item_right_star">{{ activeName }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <el-dialog
          title="文化纪"
          :visible.sync="centerDialogVisible"
          width="40%"
          center
      >
        <div class="tc">
          <img src="../../assets/images/apply/wenhuaji.png" alt="">
          <div>手机扫码进行报名</div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取 消</el-button>
        </span>
      </el-dialog>


      <el-dialog
          title="大课间"
          :visible.sync="centerDialogVisible2"
          width="40%"
          center
      >
        <div class="tc">
          <img src="../../assets/images/apply/wenhuaji.png" alt="">
          <div>手机扫码进行报名</div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible2 = false">取 消</el-button>
        </span>
      </el-dialog>

    </div>
  </div>
</template>
<script>
import SpecialTabs from "@/components/mainindex/SpecialTabs";
import ColumnTitle from "@/components/mainindex/ColumnTitle";

export default {
  name: "CulturalHistory",
  data() {
    return {
      videoAction: false,
      centerDialogVisible: false,
      centerDialogVisible2: false,
      tabList: [
        {name: "风采资讯", class: "tabs-item-active"},
        {name: "考级信息", class: ""},
        {name: "考级中心考级点", class: ""},
      ],

      cateList: [],
      personList: [],
      activeName: '',

      // columnList: [
      //   {name: "百佳四好运动员", cate_id: 16},
      //   {name: "十佳教练", cate_id: 17},
      //   {name: "十佳导师", cate_id: 19},
      //   {name: "十佳考官", cate_id: 6},
      //   {name: "十佳培训师", cate_id: 6},
      //   {name: "十佳监督", cate_id: 6},
      //   {name: "十佳执行官", cate_id: 6},
      //   {name: "十佳俱乐部", cate_id: 6},
      //   {name: "先进推进个人", cate_id: 6},
      //   {name: "十佳赛区", cate_id: 6},
      //   {name: "十佳考级中心", cate_id: 6},
      // ],

      // activeIndex: 0,
    };
  },
  mounted() {
    document.title = "文化纪"
    this.getCateList()
  },
  components: {
    SpecialTabs, ColumnTitle
  },
  methods: {
    getCateList() {
      const that = this;
      that.$api.get(
          "/api/cms/cateList",
          {
            parent_id: 1,
          },
          (res) => {
            this.cateList = res.data;
            // this.catelist.unshift({name:"全部"})
            // var i;
            // for (i = 0; i < res.data.length; i++) {
            //   this.catelist_ids.push(res.data[i].id);
            //   this.catename.push({'id':res.data[i].id,'name':res.data[i].name})
            //
            // }

            if (res.data.length > 0) {
              let row = res.data[0]
              this.activeName = row.name
              this.getPersonList(row.id)
            }

            this.getPersonList(res.data[0]['id'])
          },
      );
    },

    getPersonList(val) {
      const that = this;
      that.$api.get(
          "/api/cms/recommendList2",
          {
            cate_ids: val,
          },
          (res) => {
            this.personList = res.data;
          }
      );
    },

    toDetail(id) {
      this.$router.push({path: "/cmsdetail", query: {id: id}});
    },

    onSelectType(item) {
      this.activeName = item.name
      this.getPersonList(item.id)
    },

    // 显示h5网页打开二维码
    onWhjDetail() {
      this.centerDialogVisible = true
    },
    onDkjDetail() {
      this.centerDialogVisible2 = true
    },

    //处理video点击事件
    handlevideoAction() {
      return
      this.videoAction = !this.videoAction;
      if (!this.videoAction && this.$refs.myVideo) {
        setTimeout(() => {
          this.$refs.myVideo.pause();
          this.$refs.myVideo.currentTime = 0;
        }, 600);
      }
    },

  },

};
</script>
<style lang="scss" scoped>

.container_wrap {
  width: 1200px;
  margin: 0 auto;

  .wenhuaji-img img {
    margin-right: 15px;
    border-radius: 5px;
    cursor: pointer;

    &:nth-child(3) {
      margin: 0;
    }
  }
}

.culturalhistory {
  background: #f8f8f8;
  //min-height: 1654px;
  padding-bottom: 30px;
}

.bannerbg {
  position: relative;
  height: 464px;
  overflow: hidden;

  .bannerbg_pic {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    height: 464px;
    object-fit: cover;
    width: 100%;
    display: block;
  }

  .bannerbg_desc {
    position: relative;
    z-index: 1;
    width: 1200px;
    margin: 0 auto;
    margin-top: 76px;
    padding-left: 40px;
    box-sizing: border-box;

    .bannerbg_desc_title {
      height: 70px;
      font-size: 50px;
      font-weight: 600;
      color: #ffffff;
      line-height: 70px;
    }

    .bannerbg_desc_entitle {
      height: 42px;
      font-size: 22px;
      // font-weight: 600;
      color: #ffffff;
      line-height: 42px;
    }
  }

  .banner_videoplay_icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 3;
    width: 120px;
    height: 120px;
    object-fit: cover;

    &:hover {
      cursor: pointer;
      opacity: 0.9;
    }
  }

  video {
    height: 100%;
    width: 100%;
    object-fit: contain;
    // position: relative;
    // z-index: 0;
  }
}

.contactus_content {
  width: 1200px;
  min-height: 803px;
  background: #ffffff;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 47px 103px 73px 36px;
  margin: 0 auto;

  .contactus_content_up {
    box-sizing: border-box;
    min-height: 558px;
  }

  .contactus_content_but {
    width: 260px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background: linear-gradient(124deg, #fec835 0%, #ffad19 100%);
    border-radius: 77px;
    margin: 0 auto;
    font-size: 20px;
    font-weight: 400;
    color: #ffffff;

    &:hover {
      opacity: 0.89;
      cursor: pointer;
    }
  }
}

.tradeelite {
  //min-height: 1161px;
  background: #f8f8f8;
  overflow: hidden;
  padding-bottom: 30px;

  .header_screen {
    //height: 132px;
    //background: #ffffff;
    //box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 13px;
    padding: 0 15px;
    box-sizing: border-box;

    .header_screen_item {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      cursor: default;

      .header_screen_item_title {
        width: 30px;
        height: 36px;
        line-height: 36px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        margin-right: 41px;
      }

      .header_screen_item_els {
        flex: 1;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        .header_screen_item_el {
          height: 36px;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          line-height: 36px;
          //margin-right: 47px;
          //   margin-bottom: 23px;
          margin: 0 20px 10px 0;

          &:hover {
            cursor: pointer;
            color: #3B8DE3;
          }
        }

        .header_screen_item_el_active {
          //color: #f56057;
          font-weight: 500;
          padding: 0 10px;
          background: linear-gradient(130deg, #6BADF2 0%, #3B8DE3 100%);
          border-radius: 18px;
          color: #fff;
        }
      }
    }
  }

  .star_list {
    padding-top: 8px;
    box-sizing: border-box;
    // display: flex;
    // flex-direction: row;
    // flex-wrap: wrap;
    // justify-content: space-between;
    font-size: 0;

    .star_list_item_wrap {
      display: inline-block;
      margin-right: 30px;

      &:nth-child(3n) {
        margin-right: 0;
      }

      .star_list_item {
        // flex:25%;
        display: flex;
        flex-direction: row;
        width: 380px;
        height: 140px;
        background: #ffffff;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.06);
        border-radius: 16px;
        margin-top: 47px;
        transition: all 0.3s;

        &:hover {
          transform: scale(1.03);
          cursor: pointer;
        }

        .star_list_item_pic {
          width: 119px;
          height: 146px;
          position: relative;
          margin: 0 24px 0 8px;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            position: absolute;
            top: -15px;
            left: 0;
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
            border-radius: 10px;
            overflow: hidden;
            background: pink;
          }
        }

        .star_list_item_right {
          display: flex;
          flex-direction: column;
          flex: 1;
          box-sizing: border-box;

          .star_list_item_right_name {
            max-width: 100%;
            height: 32px;
            font-size: 22px;
            font-weight: 500;
            color: #000000;
            line-height: 32px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-top: 16px;
          }

          .star_list_item_right_des {
            max-width: 100%;
            height: 20px;
            font-size: 14px;
            font-weight: 400;
            color: #444444;
            line-height: 20px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin: 13px 0 7px 0;
          }

          .star_list_item_right_star {
            width: 88px;
            height: 28px;
            line-height: 28px;
            text-align: center;
            background: linear-gradient(133deg, #fd9d00 0%, #fa6400 100%);
            border-radius: 10px 0px 10px 10px;
            font-size: 14px;
            font-weight: 500;
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// CulturalHistory.vue?f2165efe